/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Mobile } from '@99designs/common/components/Mobile';
import { Desktop } from '@99designs/common/components/Desktop';
import MobileFilters from './MobileFilters';
import DesktopFilters from './DesktopFilters';

class Filters extends Component {
    render() {
        return (
            <form>
                <Mobile>
                    <MobileFilters onChange={this.props.onChange} />
                </Mobile>
                <Desktop>
                    <DesktopFilters onChange={this.props.onChange} />
                </Desktop>
            </form>
        );
    }
}

Filters.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default observer(Filters);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/index.jsx